<template>
  <div class="main text-left">
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="this.$store.state.automanaged" v-on:click="onAutoCheck()">
      <label class="form-check-label text-muted small" for="exampleCheck1">アカウントを自動生成します</label>
    </div>
    <div class="form-group">
      <label class="text-muted small">お名前 <span class="text-danger">*必須</span></label>
      <input type="text" class="form-control form-control-sm" v-model="input.name" :maxlength="50" placeholder="お名前">
    </div>
    <div class="form-group">
      <label class="text-muted small">ユーザーID <span class="text-danger">*必須</span></label>
      <input type="email" class="form-control form-control-sm" v-model="input.username"  :maxlength="50" placeholder="メールアドレス" v-bind:readonly="this.$store.state.automanaged">
    </div>
    <div class="form-group">
      <label class="text-muted small">パスワード <span class="text-danger">*必須</span></label>
      <input v-bind:type="this.$store.state.automanaged ? 'password':'text'" onfocus="this.type='password'" class="form-control form-control-sm" v-model="input.password" :maxlength="50" placeholder="パスワード" v-bind:readonly="this.$store.state.automanaged">
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="register()">アカウントを作成</span>
    <small class="form-text text-muted">すでにリベルタアカウントをお持ちですか？<span class="btn btn-sm btn-link" v-on:click="toLogin()">ログイン</span></small>
  </div>
</template>
<script>
import sx from '../utils/core.js'
import vl from '../utils/validate.js'
import stringRandom from 'string-random'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        name: '',
        username: '',
        password: ''
      },
      confirmdef: {
        title: 'アカウント作成',
        msg: '継続しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  mounted () {
    this.$store.state.title = 'アカウントを作成'
    this.$store.state.confirmdef = this.confirmdef
    this.init()
  },
  methods: {
    init() {
      if (!this.$store.state.automanaged) {
        this.input.name = ''
        this.input.username = ''
        this.input.password = ''
      } else {
        var uuid = localStorage.getItem("uuid")
        if (!uuid) {
          uuid = stringRandom(6, { letters: '' })
          localStorage.setItem("uuid", uuid)
        }
        var guest = 'guest' + uuid
        var passord = stringRandom(8, { letters: "abcd" })
        this.input.name = ''
        this.input.username = guest + "@liberta.com"
        this.input.password = passord
      }
    },
    onAutoCheck() {
      this.$store.state.automanaged = !this.$store.state.automanaged
      this.init()
    },
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    register() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.name) && !sx.isNothingOrEmpty(that.input.username) && !sx.isNothingOrEmpty(that.input.password)) {
        $('#myModalConfirm').modal('show')
        $("#confirm").click(function() {
          $('#myModalConfirm').modal('hide')
          if (that.$router.currentRoute.name != "Register") {
            return
          }
          var params = {
            name: that.input.name,
            username: that.input.username,
            password: that.input.password,
            email: '',
            corpid: 40,
            token: ''
          }
          if (!that.$store.state.automanaged) {
            params.email = that.input.username
          }
          sx.request(
            that.$store.state.baseurl + '/app/account/register',
            params,
            function(result) {
              if (result.status === 'ok') {
                localStorage.setItem('username', that.input.username)
                localStorage.setItem('password', sx.encrypt(that.input.password, ''))
                localStorage.setItem('automanaged', that.$store.state.automanaged)
                sx.toastSuccess('アカウントが作成されました。<br>ログイン画面に遷移します！')
                that.$router.replace({ name: 'Login' })
              } else {
                localStorage.setItem('username', that.input.username)
                localStorage.setItem('password', sx.encrypt(result.data.password, ''))
                localStorage.setItem('automanaged', that.$store.state.automanaged)
                sx.toastSuccess('アカウントは既に作成されています。<br>ログイン画面に遷移します！')
                that.$router.replace({ name: 'Login' })
              }
            },
            function(result) {
              sx.login(
                that.$store.state.baseurl + '/app/account/register',
                params,
                function(result) {
                  if (result.status === "ok") {
                    setTimeout(function() {
                      localStorage.setItem('username', that.input.username)
                      localStorage.setItem('password', sx.encrypt(that.input.password, ''))
                      localStorage.setItem('automanaged', that.$store.state.automanaged)
                      sx.toastSuccess('アカウントが作成されました。<br>ログイン画面に遷移します！')
                    }, 200);
                    that.$router.replace({ name: 'Login' })
                  } else {
                    localStorage.setItem('username', that.input.username)
                    localStorage.setItem('password', sx.encrypt(result.data.password, ''))
                    localStorage.setItem('automanaged', that.$store.state.automanaged)
                    sx.toastSuccess('アカウントは既に作成されています。<br>ログイン画面に遷移します！')
                  }
                  sx.hideWaiting();
                }
              )
              console.log('register failed')
            }
          )
          sx.hideWaiting()
        })
      } else {
        if (sx.isNothingOrEmpty(that.input.name)) {
          sx.toastError('お名前を入力してください！')
          return;
        }
        if (sx.isNothingOrEmpty(that.input.username)) {
          sx.toastError('メールアドレスを入力してください！')
          return;
        } else {
          if (!vl.isEmail(that.input.username)) {
            sx.toastError('メールアドレスが不正です！')
            return;
          }
        }
        if (sx.isNothingOrEmpty(that.input.password)) {
          sx.toastError('パスワードを入力してください！')
          return;
        }
        console.log('A username and password must be present')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding:20px;
}
</style>
